import { useState, useEffect } from 'react';

/**
 * Hook para debounce de valores
 * Útil para pesquisa, filtros e outras operações que devem aguardar
 * o usuário parar de digitar antes de executar
 * 
 * @param {*} value - Valor a ser debounced
 * @param {number} delay - Delay em ms (default: 300)
 * @returns {*} Valor debounced
 * 
 * @example
 * const [searchTerm, setSearchTerm] = useState('');
 * const debouncedSearchTerm = useDebounce(searchTerm, 300);
 * 
 * useEffect(() => {
 *   // Isso só dispara 300ms após o usuário parar de digitar
 *   loadUsers(debouncedSearchTerm);
 * }, [debouncedSearchTerm]);
 */
export function useDebounce(value, delay = 300) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    // Criar timeout
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // Limpar timeout anterior se o valor mudar antes do delay
    return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
}
